<template>
    <v-dialog v-model="isOpen" persistent max-width="600px">
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                Cancelando emisiones
                <v-progress-circular v-if="!completado" indeterminate size="30">
                </v-progress-circular>
            </v-card-title>

            <v-card-text>
                <v-progress-linear :value="progreso" color="#b11f1f" height="25">
                    <template v-slot="{ value }">
                        <span class="white--text font-weight-bold">{{ Math.round(value) }}%</span>
                    </template>
                </v-progress-linear>
                <p class="text-center mt-3 mb-4">
                    {{ procesadas }} de {{ total }} procesadas
                </p>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                            <v-alert v-if="mensajeActual" type="info" dense class="mb-3">
                                <strong>
                                    {{ emisionActual ? emisionActual + ": " : "" }}
                                </strong>
                                {{ mensajeActual }}
                            </v-alert>
                        </div>
                    </template>
                    <span>Última actualización</span>
                </v-tooltip>
                <div class="messages-container">
                    <div v-for="(msg, idx) in mensajesHistorial" :key="idx" class="message-item">
                        <v-chip :color="getChipColor(msg.tipo).bg" :text-color="getChipColor(msg.tipo).text" small
                            class="mb-2">
                            {{ msg.mensaje }}
                        </v-chip>
                    </div>
                </div>
            </v-card-text>
            <v-card-actions class="m-4">
                <v-btn v-if="!completado" dark color="#b11f1f" @click="detenerProceso" :loading="deteniendo" class="common-botton">
                    Detener proceso
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="completado" min-width="120" color="primary" @click="cerrar" class="common-botton">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { cancelarEmisionesSSE, detenerCancelacionProceso } from '@/services/cancelacionService';
export default {
    props: {
        isOpen: Boolean,
        fecha: String,
    },
    data() {
        return {
            abortController: null,
            procesoId: null,
            progreso: 0,
            procesadas: 0,
            total: 0,
            emisionActual: "",
            mensajeActual: "",
            mensajesHistorial: [],
            completado: false,
            deteniendo: false,
            styles: {
                error: { bg: '#ffebee', text: 'error' },
                info: { bg: '#e3f2fd', text: 'info' },
                success: { bg: '#e8f5e9', text: 'success' }
            }
        };
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.iniciarCancelacion();
            }
        },
    },
    methods: {
        async iniciarCancelacion() {
            this.abortController?.abort();
            this.resetearEstado();

            try {
                this.abortController = new AbortController();

                await cancelarEmisionesSSE(
                    this.fecha,
                    this.procesarMensaje,
                    this.abortController.signal
                );

                this.completado = true;
            } catch (error) {
                if (error.name !== 'AbortError') {
                    this.$toast.error('Error: ' + error.message);
                    this.completado = true;
                }
            }
        },
        procesarMensaje(data) {
            if (data.procesoId) {
                this.procesoId = data.procesoId;
            }

            if (data.porcentaje !== undefined) {
                this.procesadas = data.procesadas;
                this.total = data.total;
                this.progreso = data.porcentaje;
                this.emisionActual = data.emisionActual;
                this.mensajeActual = data.mensaje;

                this.mensajesHistorial.push({
                    mensaje: data.emisionActual ? `${data.emisionActual}: ${data.mensaje}` : data.mensaje,
                    tipo: (data.tipo || 'success').toLowerCase()
                });
            } else if (data.totalCanceladas !== undefined) {
                this.completado = true;
                this.abortController?.abort();
                this.mensajesHistorial.push({
                    mensaje: data.emisionActual ? `${data.emisionActual}: ${data.mensaje}` : data.mensaje,
                    tipo: (data.tipo || 'success').toLowerCase()
                });
                this.$emit("completado", data);
            }
        },
        async detenerProceso() {
            if (!this.procesoId || this.completado) {
                this.$toast.warning('No hay un proceso activo para detener');
                return;
            }

            this.deteniendo = true;
            try {
                await detenerCancelacionProceso(this.procesoId);
                this.$toast.warning('Enviando solicitud de detención...');
            } catch (error) {
                this.$toast.error('Error al detener: ' + error.message);
            } finally {
                this.deteniendo = false;
            }
        },
        cerrar() {
            this.abortController?.abort();
            this.$emit("update:isOpen", false);
            this.$emit("reloadData");
        },
        resetearEstado() {
            this.progreso = 0;
            this.procesadas = 0;
            this.total = 0;
            this.mensajeActual = "";
            this.emisionActual = "";
            this.mensajesHistorial = [];
            this.procesoId = null;
            this.completado = false;
        },
        getChipColor(tipo) {
            return this.styles[tipo] || this.styles.success;
        }
    },
    beforeDestroy() {
        this.abortController?.abort();
    }
};
</script>

<style scoped>
.messages-container {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 10px;
}

.message-item {
    margin-bottom: 8px;
}
</style>